/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpVmInstanceRestoreTarget } from '../models/GcpVmInstanceRestoreTarget';

export class GcpVmInstanceRestoreDestination {
  'gcpVm'?: GcpVmInstanceRestoreTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "gcpVm",
      "baseName": "gcpVm",
      "type": "GcpVmInstanceRestoreTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpVmInstanceRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

